import { makeAutoObservable, runInAction } from 'mobx';
import { hitApi } from '../database/services/ApiHelper';
import { API } from '../database/apis';
import { Book, SliderImage } from '../types';

class BookStore {
  books: Book[] = [];
  sliderImages: SliderImage[] = [];
  featuredBooks: Book[] = [];
  selectedBook: Book | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedBook(book: Book | null) {
    this.selectedBook = book;
  }

  async getSliderImages() {
    try {
      const res = await hitApi({
        endpoint: API.SLIDER_IMAGES,
        method: 'GET',
      });
      const images = Array.isArray(res?.images) ? res.images : [];
      runInAction(() => {
        this.sliderImages = images.map((img: any): SliderImage => ({
          _id: img.id,
          image: img.imageUrl,
          link: img.linkUrl ?? undefined,
        }));
      });
    } catch (e) {
      console.log('Slider images error:', e);
    }
  }

  async getFeaturedBooks() {
    try {
      const res = await hitApi({
        endpoint: API.FEATURED_BOOKS,
        method: 'GET',
      });
    
      const books = Array.isArray(res?.books) ? res.books : [];
      runInAction(() => {
        this.featuredBooks = books.map((b: any): Book => ({
          _id: b.id,
          title: b.title,
          authorName: b.author?.name ?? 'Anonymous',
          category: b.category,
          categoryName: b.category,
          description: b.description ?? '',
          coverImage: b.coverUrl,
          ad_slots: Array.isArray(b.adSlots) ? b.adSlots.map(String) : [],
        }));
      });
    } catch (e) {
      console.log('Featured books error:', e);
    }
  }
}

export const bookStore = new BookStore();
